import { ToggleSwitch } from "@/components/atoms/ToggleSwitch/ToggleSwitch";

import SectionList from "./SectionListComponent";

interface SectionToggleProps {
  title: React.ReactNode;
  icon: React.ReactNode;
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  locked?: boolean;
}
const SectionToggle = ({
  title,
  icon,
  value,
  onChange,
  disabled,
  locked,
}: SectionToggleProps) => (
  <SectionList.Item title={title} icon={icon} disabled={false}>
    <ToggleSwitch
      onChange={onChange}
      isActive={value}
      isSmall
      isOnSbcPages
      disabled={disabled}
      locked={locked}
    />
  </SectionList.Item>
);

export default SectionToggle;
